import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Footer.module.css'

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.row}>
          <span className={styles.brand}>
            <span className={styles.brandText}>Verify</span>
            <span className={styles.brandAccent}>Link</span>
          </span>
          <nav className={styles.nav} aria-label="Footer navigation">
            <Link to="/terms" className={styles.link}>
              Terms of Service
            </Link>
            <Link to="/privacy" className={styles.link}>
              Privacy Policy
            </Link>
          </nav>
        </div>
        <p className={styles.copy}>
          Files are encrypted in your browser before upload. We cannot access your data.
        </p>
      </div>
    </footer>
  )
}
